import { styled } from "@mui/material/styles";

const PageContainer = styled("div")({
  padding: "36px",
});

export default PageContainer;
